var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Frt-Cadastro-Principal"},[_c('PageTitle',{attrs:{"icon":"fa fa-group","main":"Cadastro","sub":"Cadastro -> Frota / Fabricantes / Chassi"}}),_c('div',{staticClass:"Fol-Cadastro-Principal"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Frota","active":""}},[_c('Frota')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }